import axiosInstance from "./index";

export const getTemplates = () => {
  return axiosInstance.get("templates");
};

export const getSessions = () => {
  return axiosInstance.get("VM");
};

export const getOneSession = (id = "") => {
  return axiosInstance.get(`VM/${id}`);
};

export const keepVMAlive = () => {
  return axiosInstance.post(`VM/keepalive`);
};

export const createVM = (body = {}) => {
  return axiosInstance.post("VM", { ...body });
};

export const stopSession = (id = "") => {
  return axiosInstance.post(`VM/stop/${id}`);
};

export const stopAllSessions = () => {
  return axiosInstance.post(`VM/stop`);
};

export const updateSessionDetails = (sessionId = "", body = {}) => {
  return axiosInstance.put(`VM/${sessionId}`, { ...body });
};

export const deleteSession = (sessionId = "") => {
  return axiosInstance.delete(`VM/${sessionId}`);
};

export const getVMJob = (jobId = "") => {
  return axiosInstance.get(`VM/job/${jobId}`);
};

export const connectVNC = (sessionId = "") => {
  return axiosInstance.post(`VM/${sessionId}/vnc`);
};

export const getCredits = () => {
  return axiosInstance.get(`vm/credits`);
};
